/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Actions for SettingsPositions component
 *
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @version 1.3.2
 * @since 1.3.0
 */

import { createAction } from '../../../../modules/app/createAction';
import {
    ADD_SETTINGS_POSITION_ACTION,
    ADD_SETTINGS_POSITION_FAILURE,
    ADD_SETTINGS_POSITION_SUCCESS,
    GET_SETTINGS_POSITIONS_LIST_ACTION,
    GET_SETTINGS_POSITIONS_LIST_FAILURE,
    GET_SETTINGS_POSITIONS_LIST_SUCCESS,
    REMOVE_SETTINGS_POSITION_ACTION,
    REMOVE_SETTINGS_POSITION_FAILURE,
    REMOVE_SETTINGS_POSITION_SUCCESS,
} from './settingsPositionsConstants';
import {
    IGetSettingsPositionsListActionPayload,
    IGetSettingsPositionsListSuccessPayload,
    IRemoveSettingsPositionSuccessPayload,
    TAddSettingsPositionAction,
    TAddSettingsPositionFailure,
    TAddSettingsPositionSuccess,
    TGetSettingsPositionsListAction,
    TGetSettingsPositionsListFailed,
    TGetSettingsPositionsListSuccess,
    TRemoveSettingsPositionAction,
    TRemoveSettingsPositionFailure,
    TRemoveSettingsPositionSuccess,
} from './settingsPositionsTypes';

/**
 * Settings Labels
 */

export const getSettingsPositionsListAction =
    (payload: IGetSettingsPositionsListActionPayload): TGetSettingsPositionsListAction =>
        createAction(GET_SETTINGS_POSITIONS_LIST_ACTION, payload);

export const getSettingsPositionsListSuccess =
    (payload: IGetSettingsPositionsListSuccessPayload): TGetSettingsPositionsListSuccess =>
        createAction(GET_SETTINGS_POSITIONS_LIST_SUCCESS, payload);

export const getSettingsPositionsListFailure =
    (payload: string): TGetSettingsPositionsListFailed =>
        createAction(GET_SETTINGS_POSITIONS_LIST_FAILURE, payload);

/**
 * Add Label
 */

export const addSettingsPositionAction = (payload: string): TAddSettingsPositionAction =>
    createAction(ADD_SETTINGS_POSITION_ACTION, payload);

export const addSettingsPositionSuccess = (): TAddSettingsPositionSuccess =>
    createAction(ADD_SETTINGS_POSITION_SUCCESS);

export const addSettingsPositionFailure = (payload: string): TAddSettingsPositionFailure =>
    createAction(ADD_SETTINGS_POSITION_FAILURE, payload);

/**
 * Remove Label
 */

export const removeSettingsPositionAction = (payload: number): TRemoveSettingsPositionAction =>
    createAction(REMOVE_SETTINGS_POSITION_ACTION, payload);

export const removeSettingsPositionSuccess = (payload: IRemoveSettingsPositionSuccessPayload):
    TRemoveSettingsPositionSuccess => createAction(REMOVE_SETTINGS_POSITION_SUCCESS, payload);

export const removeSettingsPositionFailure = (payload: string): TRemoveSettingsPositionFailure =>
    createAction(REMOVE_SETTINGS_POSITION_FAILURE, payload);
